/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { fetchCloudRun } from "@/api/Helper";

export const createChatbot = async (chatbotName: string): Promise<string> => {
  const response = await fetchCloudRun(
    process.env.VUE_APP_BASE_URL + "/bot/chatbots",
    "POST",
    {},
    {
      name: chatbotName,
    }
  );
  return response.result.id;
};
